export const BRAND_NAME = "TerraZoon";
export const SUPPORT_EMAIL = "terrazoon.support@gmail.com";
export const WEBSITE_URL = "https://terrazoon.com";
export const DELIVERY_MESSAGE = "Sorry, TerraZoon currently delivers only in Lucknow. We're coming to your area soon!";
